export default __webpack_public_path__ + "static/media/make-move.5a0a3fdd.wav";